[
  {
    "codigoIbge": 3302700,
    "nome": "Maricá",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 4
  },
  {
    "codigoIbge": 3534401,
    "nome": "Osasco",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 7
  },
  {
    "codigoIbge": 3303302,
    "nome": "Niterói",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 10
  },
  {
    "codigoIbge": 3518800,
    "nome": "Guarulhos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 11
  },
  {
    "codigoIbge": 3509502,
    "nome": "Campinas",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 13
  },
  {
    "codigoIbge": 3305505,
    "nome": "Saquarema",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 14
  },
  {
    "codigoIbge": 3536505,
    "nome": "Paulínia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 15
  },
  {
    "codigoIbge": 3505708,
    "nome": "Barueri",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 16
  },
  {
    "codigoIbge": 3301702,
    "nome": "Duque de Caxias",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 19
  },
  {
    "codigoIbge": 3548708,
    "nome": "São Bernardo do Campo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 20
  },
  {
    "codigoIbge": 3525904,
    "nome": "Jundiaí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 21
  },
  {
    "codigoIbge": 3549904,
    "nome": "São José dos Campos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 23
  },
  {
    "codigoIbge": 3552205,
    "nome": "Sorocaba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 24
  },
  {
    "codigoIbge": 4208203,
    "nome": "Itajaí",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 25
  },
  {
    "codigoIbge": 3301009,
    "nome": "Campos dos Goytacazes",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 26
  },
  {
    "codigoIbge": 3170206,
    "nome": "Uberlândia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 27
  },
  {
    "codigoIbge": 3106705,
    "nome": "Betim",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 28
  },
  {
    "codigoIbge": 3543402,
    "nome": "Ribeirão Preto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 29
  },
  {
    "codigoIbge": 4209102,
    "nome": "Joinville",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 30
  },
  {
    "codigoIbge": 3118601,
    "nome": "Contagem",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 31
  },
  {
    "codigoIbge": 3538709,
    "nome": "Piracicaba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 32
  },
  {
    "codigoIbge": 3547809,
    "nome": "Santo André",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 36
  },
  {
    "codigoIbge": 3205002,
    "nome": "Serra",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 37
  },
  {
    "codigoIbge": 4305108,
    "nome": "Caxias do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 38
  },
  {
    "codigoIbge": 4125506,
    "nome": "São José dos Pinhais",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 40
  },
  {
    "codigoIbge": 4101804,
    "nome": "Araucária",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 41
  },
  {
    "codigoIbge": 2905701,
    "nome": "Camaçari",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 42
  },
  {
    "codigoIbge": 4304606,
    "nome": "Canoas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 44
  },
  {
    "codigoIbge": 3513504,
    "nome": "Cubatão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 45
  },
  {
    "codigoIbge": 3548500,
    "nome": "Santos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 46
  },
  {
    "codigoIbge": 3520509,
    "nome": "Indaiatuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 48
  },
  {
    "codigoIbge": 4115200,
    "nome": "Maringá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 49
  },
  {
    "codigoIbge": 4113700,
    "nome": "Londrina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 51
  },
  {
    "codigoIbge": 2929206,
    "nome": "São Francisco do Conde",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 53
  },
  {
    "codigoIbge": 1505536,
    "nome": "Parauapebas",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 54
  },
  {
    "codigoIbge": 3520400,
    "nome": "Ilhabela",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 55
  },
  {
    "codigoIbge": 3509205,
    "nome": "Cajamar",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 57
  },
  {
    "codigoIbge": 3529401,
    "nome": "Mauá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 59
  },
  {
    "codigoIbge": 3549805,
    "nome": "São José do Rio Preto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 60
  },
  {
    "codigoIbge": 3170107,
    "nome": "Uberaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 61
  },
  {
    "codigoIbge": 4119905,
    "nome": "Ponta Grossa",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 62
  },
  {
    "codigoIbge": 4202404,
    "nome": "Blumenau",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 63
  },
  {
    "codigoIbge": 3530607,
    "nome": "Mogi das Cruzes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 64
  },
  {
    "codigoIbge": 3136702,
    "nome": "Juiz de Fora",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 66
  },
  {
    "codigoIbge": 5218805,
    "nome": "Rio Verde",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 67
  },
  {
    "codigoIbge": 3519071,
    "nome": "Hortolândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 68
  },
  {
    "codigoIbge": 3304904,
    "nome": "São Gonçalo",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 70
  },
  {
    "codigoIbge": 3513801,
    "nome": "Diadema",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 71
  },
  {
    "codigoIbge": 3303500,
    "nome": "Nova Iguaçu",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 72
  },
  {
    "codigoIbge": 2910800,
    "nome": "Feira de Santana",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 73
  },
  {
    "codigoIbge": 3302403,
    "nome": "Macaé",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 74
  },
  {
    "codigoIbge": 5201108,
    "nome": "Anápolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 75
  },
  {
    "codigoIbge": 3527306,
    "nome": "Louveira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 76
  },
  {
    "codigoIbge": 5201405,
    "nome": "Aparecida de Goiânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 77
  },
  {
    "codigoIbge": 3526902,
    "nome": "Limeira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 78
  },
  {
    "codigoIbge": 3131307,
    "nome": "Ipatinga",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 79
  },
  {
    "codigoIbge": 3550704,
    "nome": "São Sebastião",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 80
  },
  {
    "codigoIbge": 3506003,
    "nome": "Bauru",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 81
  },
  {
    "codigoIbge": 2607901,
    "nome": "Jaboatão dos Guararapes",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 82
  },
  {
    "codigoIbge": 3554102,
    "nome": "Taubaté",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 83
  },
  {
    "codigoIbge": 3548807,
    "nome": "São Caetano do Sul",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 84
  },
  {
    "codigoIbge": 4104808,
    "nome": "Cascavel",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 85
  },
  {
    "codigoIbge": 2607208,
    "nome": "Ipojuca",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 86
  },
  {
    "codigoIbge": 3524402,
    "nome": "Jacareí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 87
  },
  {
    "codigoIbge": 3552403,
    "nome": "Sumaré",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 88
  },
  {
    "codigoIbge": 3125101,
    "nome": "Extrema",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 89
  },
  {
    "codigoIbge": 4108304,
    "nome": "Foz do Iguaçu",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 90
  },
  {
    "codigoIbge": 5003702,
    "nome": "Dourados",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 91
  },
  {
    "codigoIbge": 3513009,
    "nome": "Cotia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 92
  },
  {
    "codigoIbge": 3205200,
    "nome": "Vila Velha",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 93
  },
  {
    "codigoIbge": 3552502,
    "nome": "Suzano",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 94
  },
  {
    "codigoIbge": 3501608,
    "nome": "Americana",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 95
  },
  {
    "codigoIbge": 3515004,
    "nome": "Embu das Artes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 96
  },
  {
    "codigoIbge": 4118204,
    "nome": "Paranaguá",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 97
  },
  {
    "codigoIbge": 1502152,
    "nome": "Canaã dos Carajás",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 98
  },
  {
    "codigoIbge": 3303906,
    "nome": "Petrópolis",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 99
  },
  {
    "codigoIbge": 5107602,
    "nome": "Rondonópolis",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 100
  },
  {
    "codigoIbge": 4204202,
    "nome": "Chapecó",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 101
  },
  {
    "codigoIbge": 3548906,
    "nome": "São Carlos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 102
  },
  {
    "codigoIbge": 3306305,
    "nome": "Volta Redonda",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 104
  },
  {
    "codigoIbge": 3300704,
    "nome": "Cabo Frio",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 105
  },
  {
    "codigoIbge": 3522505,
    "nome": "Itapevi",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 107
  },
  {
    "codigoIbge": 3167202,
    "nome": "Sete Lagoas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 108
  },
  {
    "codigoIbge": 3201308,
    "nome": "Cariacica",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 109
  },
  {
    "codigoIbge": 2602902,
    "nome": "Cabo de Santo Agostinho",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 110
  },
  {
    "codigoIbge": 4216602,
    "nome": "São José",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 111
  },
  {
    "codigoIbge": 5107925,
    "nome": "Sorriso",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 112
  },
  {
    "codigoIbge": 3556701,
    "nome": "Vinhedo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 113
  },
  {
    "codigoIbge": 2307650,
    "nome": "Maracanaú",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 114
  },
  {
    "codigoIbge": 3524709,
    "nome": "Jaguariúna",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 115
  },
  {
    "codigoIbge": 3543907,
    "nome": "Rio Claro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 116
  },
  {
    "codigoIbge": 4208906,
    "nome": "Jaraguá do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 117
  },
  {
    "codigoIbge": 3538006,
    "nome": "Pindamonhangaba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 118
  },
  {
    "codigoIbge": 4314100,
    "nome": "Passo Fundo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 119
  },
  {
    "codigoIbge": 3503208,
    "nome": "Araraquara",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 120
  },
  {
    "codigoIbge": 3516200,
    "nome": "Franca",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 121
  },
  {
    "codigoIbge": 4315602,
    "nome": "Rio Grande",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 122
  },
  {
    "codigoIbge": 5008305,
    "nome": "Três Lagoas",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 123
  },
  {
    "codigoIbge": 4309209,
    "nome": "Gravataí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 124
  },
  {
    "codigoIbge": 3305000,
    "nome": "São João da Barra",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 125
  },
  {
    "codigoIbge": 3547304,
    "nome": "Santana de Parnaíba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 126
  },
  {
    "codigoIbge": 2606200,
    "nome": "Goiana",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 127
  },
  {
    "codigoIbge": 3152501,
    "nome": "Pouso Alegre",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 128
  },
  {
    "codigoIbge": 3143302,
    "nome": "Montes Claros",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 129
  },
  {
    "codigoIbge": 1504208,
    "nome": "Marabá",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 130
  },
  {
    "codigoIbge": 3144805,
    "nome": "Nova Lima",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 131
  },
  {
    "codigoIbge": 2919553,
    "nome": "Luís Eduardo Magalhães",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 133
  },
  {
    "codigoIbge": 3523909,
    "nome": "Itu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 134
  },
  {
    "codigoIbge": 4314407,
    "nome": "Pelotas",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 135
  },
  {
    "codigoIbge": 3304201,
    "nome": "Resende",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 136
  },
  {
    "codigoIbge": 5107909,
    "nome": "Sinop",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 137
  },
  {
    "codigoIbge": 5108402,
    "nome": "Várzea Grande",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 138
  },
  {
    "codigoIbge": 2504009,
    "nome": "Campina Grande",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 139
  },
  {
    "codigoIbge": 3518701,
    "nome": "Guarujá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 140
  },
  {
    "codigoIbge": 4204608,
    "nome": "Criciúma",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 142
  },
  {
    "codigoIbge": 4316808,
    "nome": "Santa Cruz do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 143
  },
  {
    "codigoIbge": 5205109,
    "nome": "Catalão",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 144
  },
  {
    "codigoIbge": 4318705,
    "nome": "São Leopoldo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 145
  },
  {
    "codigoIbge": 3300100,
    "nome": "Angra dos Reis",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 146
  },
  {
    "codigoIbge": 3529005,
    "nome": "Marília",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 147
  },
  {
    "codigoIbge": 3552809,
    "nome": "Taboão da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 148
  },
  {
    "codigoIbge": 3304524,
    "nome": "Rio das Ostras",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 149
  },
  {
    "codigoIbge": 4313409,
    "nome": "Novo Hamburgo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 150
  },
  {
    "codigoIbge": 3545209,
    "nome": "Salto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 151
  },
  {
    "codigoIbge": 3523107,
    "nome": "Itaquaquecetuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 152
  },
  {
    "codigoIbge": 3305109,
    "nome": "São João de Meriti",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 153
  },
  {
    "codigoIbge": 5211909,
    "nome": "Jataí",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 154
  },
  {
    "codigoIbge": 3541406,
    "nome": "Presidente Prudente",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 155
  },
  {
    "codigoIbge": 3502804,
    "nome": "Araçatuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 156
  },
  {
    "codigoIbge": 3541000,
    "nome": "Praia Grande",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 157
  },
  {
    "codigoIbge": 1500800,
    "nome": "Ananindeua",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 158
  },
  {
    "codigoIbge": 3170701,
    "nome": "Varginha",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 159
  },
  {
    "codigoIbge": 4202909,
    "nome": "Brusque",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 160
  },
  {
    "codigoIbge": 2303709,
    "nome": "Caucaia",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 161
  },
  {
    "codigoIbge": 4316907,
    "nome": "Santa Maria",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 162
  },
  {
    "codigoIbge": 3151800,
    "nome": "Poços de Caldas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 163
  },
  {
    "codigoIbge": 2604106,
    "nome": "Caruaru",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 164
  },
  {
    "codigoIbge": 2408003,
    "nome": "Mossoró",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 165
  },
  {
    "codigoIbge": 3300456,
    "nome": "Belford Roxo",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 166
  },
  {
    "codigoIbge": 2928901,
    "nome": "São Desidério",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 167
  },
  {
    "codigoIbge": 3524006,
    "nome": "Itupeva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 168
  },
  {
    "codigoIbge": 3503901,
    "nome": "Arujá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 169
  },
  {
    "codigoIbge": 3545803,
    "nome": "Santa Bárbara d'Oeste",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 170
  },
  {
    "codigoIbge": 3300209,
    "nome": "Araruama",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 171
  },
  {
    "codigoIbge": 4109401,
    "nome": "Guarapuava",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 172
  },
  {
    "codigoIbge": 2933307,
    "nome": "Vitória da Conquista",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 173
  },
  {
    "codigoIbge": 3556206,
    "nome": "Valinhos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 174
  },
  {
    "codigoIbge": 3507605,
    "nome": "Bragança Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 175
  },
  {
    "codigoIbge": 4211900,
    "nome": "Palhoça",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 176
  },
  {
    "codigoIbge": 3302007,
    "nome": "Itaguaí",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 177
  },
  {
    "codigoIbge": 3523404,
    "nome": "Itatiba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 178
  },
  {
    "codigoIbge": 3527108,
    "nome": "Lins",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 179
  },
  {
    "codigoIbge": 2611101,
    "nome": "Petrolina",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 180
  },
  {
    "codigoIbge": 3504107,
    "nome": "Atibaia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 181
  },
  {
    "codigoIbge": 3122306,
    "nome": "Divinópolis",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 182
  },
  {
    "codigoIbge": 2105302,
    "nome": "Imperatriz",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 183
  },
  {
    "codigoIbge": 2903201,
    "nome": "Barreiras",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 184
  },
  {
    "codigoIbge": 3104007,
    "nome": "Araxá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 185
  },
  {
    "codigoIbge": 4119152,
    "nome": "Pinhais",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 186
  },
  {
    "codigoIbge": 3304151,
    "nome": "Quissamã",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 187
  },
  {
    "codigoIbge": 3118007,
    "nome": "Congonhas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 188
  },
  {
    "codigoIbge": 3503307,
    "nome": "Araras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 189
  },
  {
    "codigoIbge": 4127700,
    "nome": "Toledo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 190
  },
  {
    "codigoIbge": 1501303,
    "nome": "Barcarena",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 191
  },
  {
    "codigoIbge": 3518404,
    "nome": "Guaratinguetá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 192
  },
  {
    "codigoIbge": 4309308,
    "nome": "Guaíba",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 193
  },
  {
    "codigoIbge": 3530706,
    "nome": "Mogi Guaçu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 194
  },
  {
    "codigoIbge": 3204302,
    "nome": "Presidente Kennedy",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 195
  },
  {
    "codigoIbge": 4322004,
    "nome": "Triunfo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 196
  },
  {
    "codigoIbge": 3551702,
    "nome": "Sertãozinho",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 197
  },
  {
    "codigoIbge": 3127701,
    "nome": "Governador Valadares",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 198
  },
  {
    "codigoIbge": 2101400,
    "nome": "Balsas",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 199
  },
  {
    "codigoIbge": 2919207,
    "nome": "Lauro de Freitas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 200
  },
  {
    "codigoIbge": 5105259,
    "nome": "Lucas do Rio Verde",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 201
  },
  {
    "codigoIbge": 5107040,
    "nome": "Primavera do Leste",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 202
  },
  {
    "codigoIbge": 4201307,
    "nome": "Araquari",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 203
  },
  {
    "codigoIbge": 4202008,
    "nome": "Balneário Camboriú",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 204
  },
  {
    "codigoIbge": 3203205,
    "nome": "Linhares",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 205
  },
  {
    "codigoIbge": 3510609,
    "nome": "Carapicuíba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 206
  },
  {
    "codigoIbge": 1506807,
    "nome": "Santarém",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 207
  },
  {
    "codigoIbge": 4302105,
    "nome": "Bento Gonçalves",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 208
  },
  {
    "codigoIbge": 4216206,
    "nome": "São Francisco do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 209
  },
  {
    "codigoIbge": 4307005,
    "nome": "Erechim",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 210
  },
  {
    "codigoIbge": 4209300,
    "nome": "Lages",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 211
  },
  {
    "codigoIbge": 2403251,
    "nome": "Parnamirim",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 212
  },
  {
    "codigoIbge": 5106224,
    "nome": "Nova Mutum",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 213
  },
  {
    "codigoIbge": 2930709,
    "nome": "Simões Filho",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 214
  },
  {
    "codigoIbge": 3131703,
    "nome": "Itabira",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 215
  },
  {
    "codigoIbge": 3530805,
    "nome": "Mogi Mirim",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 216
  },
  {
    "codigoIbge": 3146107,
    "nome": "Ouro Preto",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 217
  },
  {
    "codigoIbge": 5102637,
    "nome": "Campo Novo do Parecis",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 218
  },
  {
    "codigoIbge": 3131901,
    "nome": "Itabirito",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 219
  },
  {
    "codigoIbge": 3522307,
    "nome": "Itapetininga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 220
  },
  {
    "codigoIbge": 3203320,
    "nome": "Marataízes",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 221
  },
  {
    "codigoIbge": 2906501,
    "nome": "Candeias",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 222
  },
  {
    "codigoIbge": 4211306,
    "nome": "Navegantes",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 223
  },
  {
    "codigoIbge": 3148004,
    "nome": "Patos de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 224
  },
  {
    "codigoIbge": 4303103,
    "nome": "Cachoeirinha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 225
  },
  {
    "codigoIbge": 3300258,
    "nome": "Arraial do Cabo",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 226
  },
  {
    "codigoIbge": 2312403,
    "nome": "São Gonçalo do Amarante",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 227
  },
  {
    "codigoIbge": 3303401,
    "nome": "Nova Friburgo",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 228
  },
  {
    "codigoIbge": 3103504,
    "nome": "Araguari",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 229
  },
  {
    "codigoIbge": 3551009,
    "nome": "São Vicente",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 230
  },
  {
    "codigoIbge": 3507506,
    "nome": "Botucatu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 231
  },
  {
    "codigoIbge": 2913606,
    "nome": "Ilhéus",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 232
  },
  {
    "codigoIbge": 3508405,
    "nome": "Cabreúva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 233
  },
  {
    "codigoIbge": 3300407,
    "nome": "Barra Mansa",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 234
  },
  {
    "codigoIbge": 5211503,
    "nome": "Itumbiara",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 235
  },
  {
    "codigoIbge": 3147006,
    "nome": "Paracatu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 236
  },
  {
    "codigoIbge": 4312401,
    "nome": "Montenegro",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 237
  },
  {
    "codigoIbge": 2609600,
    "nome": "Olinda",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 238
  },
  {
    "codigoIbge": 2610707,
    "nome": "Paulista",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 239
  },
  {
    "codigoIbge": 3200607,
    "nome": "Aracruz",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 240
  },
  {
    "codigoIbge": 4105805,
    "nome": "Colombo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 241
  },
  {
    "codigoIbge": 3201209,
    "nome": "Cachoeiro de Itapemirim",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 242
  },
  {
    "codigoIbge": 5212501,
    "nome": "Luziânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 243
  },
  {
    "codigoIbge": 3302254,
    "nome": "Itatiaia",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 244
  },
  {
    "codigoIbge": 3525300,
    "nome": "Jaú",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 245
  },
  {
    "codigoIbge": 3305802,
    "nome": "Teresópolis",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 246
  },
  {
    "codigoIbge": 3529302,
    "nome": "Matão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 247
  },
  {
    "codigoIbge": 3505500,
    "nome": "Barretos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 248
  },
  {
    "codigoIbge": 1702109,
    "nome": "Araguaína",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 249
  },
  {
    "codigoIbge": 3202801,
    "nome": "Itapemirim",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 250
  },
  {
    "codigoIbge": 3501905,
    "nome": "Amparo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 251
  },
  {
    "codigoIbge": 4103701,
    "nome": "Cambé",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 252
  },
  {
    "codigoIbge": 4104204,
    "nome": "Campo Largo",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 253
  },
  {
    "codigoIbge": 4311403,
    "nome": "Lajeado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 254
  },
  {
    "codigoIbge": 3511102,
    "nome": "Catanduva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 255
  },
  {
    "codigoIbge": 2312908,
    "nome": "Sobral",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 256
  },
  {
    "codigoIbge": 1508100,
    "nome": "Tucuruí",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 257
  },
  {
    "codigoIbge": 2911105,
    "nome": "Formosa do Rio Preto",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 258
  },
  {
    "codigoIbge": 3554003,
    "nome": "Tatuí",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 259
  },
  {
    "codigoIbge": 3526803,
    "nome": "Lençóis Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 260
  },
  {
    "codigoIbge": 3508504,
    "nome": "Caçapava",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 261
  },
  {
    "codigoIbge": 2700300,
    "nome": "Arapiraca",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 262
  },
  {
    "codigoIbge": 5107875,
    "nome": "Sapezal",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 263
  },
  {
    "codigoIbge": 5220454,
    "nome": "Senador Canedo",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 264
  },
  {
    "codigoIbge": 2307304,
    "nome": "Juazeiro do Norte",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 265
  },
  {
    "codigoIbge": 5005400,
    "nome": "Maracaju",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 266
  },
  {
    "codigoIbge": 3157807,
    "nome": "Santa Luzia",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 267
  },
  {
    "codigoIbge": 3154606,
    "nome": "Ribeirão das Neves",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 268
  },
  {
    "codigoIbge": 3525003,
    "nome": "Jandira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 269
  },
  {
    "codigoIbge": 5206206,
    "nome": "Cristalina",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 270
  },
  {
    "codigoIbge": 4104303,
    "nome": "Campo Mourão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 271
  },
  {
    "codigoIbge": 1502400,
    "nome": "Castanhal",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 272
  },
  {
    "codigoIbge": 3301900,
    "nome": "Itaboraí",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 273
  },
  {
    "codigoIbge": 3510500,
    "nome": "Caraguatatuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 274
  },
  {
    "codigoIbge": 2918407,
    "nome": "Juazeiro",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 275
  },
  {
    "codigoIbge": 3306008,
    "nome": "Três Rios",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 276
  },
  {
    "codigoIbge": 3522604,
    "nome": "Itapira",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 277
  },
  {
    "codigoIbge": 4310207,
    "nome": "Ijuí",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 278
  },
  {
    "codigoIbge": 3168705,
    "nome": "Timóteo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 279
  },
  {
    "codigoIbge": 4118501,
    "nome": "Pato Branco",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 280
  },
  {
    "codigoIbge": 2616407,
    "nome": "Vitória de Santo Antão",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 281
  },
  {
    "codigoIbge": 5103502,
    "nome": "Diamantino",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 282
  },
  {
    "codigoIbge": 4218707,
    "nome": "Tubarão",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 283
  },
  {
    "codigoIbge": 3133808,
    "nome": "Itaúna",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 284
  },
  {
    "codigoIbge": 3522208,
    "nome": "Itapecerica da Serra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 285
  },
  {
    "codigoIbge": 5102678,
    "nome": "Campo Verde",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 286
  },
  {
    "codigoIbge": 3515707,
    "nome": "Ferraz de Vasconcelos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 287
  },
  {
    "codigoIbge": 3509007,
    "nome": "Caieiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 288
  },
  {
    "codigoIbge": 2900702,
    "nome": "Alagoinhas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 289
  },
  {
    "codigoIbge": 3526704,
    "nome": "Leme",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 290
  },
  {
    "codigoIbge": 3502754,
    "nome": "Araçariguama",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 291
  },
  {
    "codigoIbge": 4204301,
    "nome": "Concórdia",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 292
  },
  {
    "codigoIbge": 4101507,
    "nome": "Arapongas",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 293
  },
  {
    "codigoIbge": 3140001,
    "nome": "Mariana",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 294
  },
  {
    "codigoIbge": 3516408,
    "nome": "Franco da Rocha",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 295
  },
  {
    "codigoIbge": 4127106,
    "nome": "Telêmaco Borba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 296
  },
  {
    "codigoIbge": 1505502,
    "nome": "Paragominas",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 297
  },
  {
    "codigoIbge": 3136207,
    "nome": "João Monlevade",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 298
  },
  {
    "codigoIbge": 3145901,
    "nome": "Ouro Branco",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 299
  },
  {
    "codigoIbge": 4205902,
    "nome": "Gaspar",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 300
  },
  {
    "codigoIbge": 1100122,
    "nome": "Ji-Paraná",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 301
  },
  {
    "codigoIbge": 4203006,
    "nome": "Caçador",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 302
  },
  {
    "codigoIbge": 3170404,
    "nome": "Unaí",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 303
  },
  {
    "codigoIbge": 1301209,
    "nome": "Coari",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 304
  },
  {
    "codigoIbge": 5107958,
    "nome": "Tangará da Serra",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 305
  },
  {
    "codigoIbge": 4215802,
    "nome": "São Bento do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 306
  },
  {
    "codigoIbge": 2914802,
    "nome": "Itabuna",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 307
  },
  {
    "codigoIbge": 3302502,
    "nome": "Magé",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 308
  },
  {
    "codigoIbge": 3506102,
    "nome": "Bebedouro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 309
  },
  {
    "codigoIbge": 3531803,
    "nome": "Monte Mor",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 310
  },
  {
    "codigoIbge": 3549102,
    "nome": "São João da Boa Vista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 311
  },
  {
    "codigoIbge": 5006606,
    "nome": "Ponta Porã",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 312
  },
  {
    "codigoIbge": 3543303,
    "nome": "Ribeirão Pires",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 313
  },
  {
    "codigoIbge": 4323002,
    "nome": "Viamão",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 314
  },
  {
    "codigoIbge": 3533403,
    "nome": "Nova Odessa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 315
  },
  {
    "codigoIbge": 3504008,
    "nome": "Assis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 316
  },
  {
    "codigoIbge": 4307906,
    "nome": "Farroupilha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 317
  },
  {
    "codigoIbge": 3147105,
    "nome": "Pará de Minas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 318
  },
  {
    "codigoIbge": 2304285,
    "nome": "Eusébio",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 319
  },
  {
    "codigoIbge": 3557006,
    "nome": "Votorantim",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 320
  },
  {
    "codigoIbge": 1100304,
    "nome": "Vilhena",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 321
  },
  {
    "codigoIbge": 4109807,
    "nome": "Ibiporã",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 322
  },
  {
    "codigoIbge": 3506508,
    "nome": "Birigui",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 323
  },
  {
    "codigoIbge": 3534708,
    "nome": "Ourinhos",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 324
  },
  {
    "codigoIbge": 2925303,
    "nome": "Porto Seguro",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 325
  },
  {
    "codigoIbge": 2301000,
    "nome": "Aquiraz",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 326
  },
  {
    "codigoIbge": 3201506,
    "nome": "Colatina",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 327
  },
  {
    "codigoIbge": 3303807,
    "nome": "Paraty",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 328
  },
  {
    "codigoIbge": 3148103,
    "nome": "Patrocínio",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 329
  },
  {
    "codigoIbge": 5213103,
    "nome": "Mineiros",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 330
  },
  {
    "codigoIbge": 3304144,
    "nome": "Queimados",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 331
  },
  {
    "codigoIbge": 4128104,
    "nome": "Umuarama",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 332
  },
  {
    "codigoIbge": 3134202,
    "nome": "Ituiutaba",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 333
  },
  {
    "codigoIbge": 4320008,
    "nome": "Sapucaia do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 334
  },
  {
    "codigoIbge": 3540606,
    "nome": "Porto Feliz",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 335
  },
  {
    "codigoIbge": 3556503,
    "nome": "Várzea Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 336
  },
  {
    "codigoIbge": 4207007,
    "nome": "Içara",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 337
  },
  {
    "codigoIbge": 4101408,
    "nome": "Apucarana",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 338
  },
  {
    "codigoIbge": 4214805,
    "nome": "Rio do Sul",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 339
  },
  {
    "codigoIbge": 4307708,
    "nome": "Esteio",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 340
  },
  {
    "codigoIbge": 4104907,
    "nome": "Castro",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 341
  },
  {
    "codigoIbge": 4304705,
    "nome": "Carazinho",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 342
  },
  {
    "codigoIbge": 3305554,
    "nome": "Seropédica",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 343
  },
  {
    "codigoIbge": 3512407,
    "nome": "Cordeirópolis",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 344
  },
  {
    "codigoIbge": 3522406,
    "nome": "Itapeva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 345
  },
  {
    "codigoIbge": 4122404,
    "nome": "Rolândia",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 346
  },
  {
    "codigoIbge": 3527207,
    "nome": "Lorena",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 347
  },
  {
    "codigoIbge": 2100055,
    "nome": "Açailândia",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 348
  },
  {
    "codigoIbge": 3300233,
    "nome": "Armação dos Búzios",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 349
  },
  {
    "codigoIbge": 3557105,
    "nome": "Votuporanga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 350
  },
  {
    "codigoIbge": 4301602,
    "nome": "Bagé",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 351
  },
  {
    "codigoIbge": 3139409,
    "nome": "Manhuaçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 352
  },
  {
    "codigoIbge": 3132404,
    "nome": "Itajubá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 353
  },
  {
    "codigoIbge": 4306106,
    "nome": "Cruz Alta",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 354
  },
  {
    "codigoIbge": 2909307,
    "nome": "Correntina",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 355
  },
  {
    "codigoIbge": 3205101,
    "nome": "Viana",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 356
  },
  {
    "codigoIbge": 1508357,
    "nome": "Vitória do Xingu",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 357
  },
  {
    "codigoIbge": 4107652,
    "nome": "Fazenda Rio Grande",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 358
  },
  {
    "codigoIbge": 4317202,
    "nome": "Santa Rosa",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 359
  },
  {
    "codigoIbge": 4207502,
    "nome": "Indaial",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 360
  },
  {
    "codigoIbge": 3502101,
    "nome": "Andradina",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 361
  },
  {
    "codigoIbge": 3539806,
    "nome": "Poá",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 362
  },
  {
    "codigoIbge": 2924009,
    "nome": "Paulo Afonso",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 363
  },
  {
    "codigoIbge": 3536703,
    "nome": "Pederneiras",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 364
  },
  {
    "codigoIbge": 3507001,
    "nome": "Boituva",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 365
  },
  {
    "codigoIbge": 4108403,
    "nome": "Francisco Beltrão",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 366
  },
  {
    "codigoIbge": 5007901,
    "nome": "Sidrolândia",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 367
  },
  {
    "codigoIbge": 3304110,
    "nome": "Porto Real",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 368
  },
  {
    "codigoIbge": 2910727,
    "nome": "Eunápolis",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 369
  },
  {
    "codigoIbge": 3156700,
    "nome": "Sabará",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 370
  },
  {
    "codigoIbge": 3128709,
    "nome": "Guaxupé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 371
  },
  {
    "codigoIbge": 5107065,
    "nome": "Querência",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 372
  },
  {
    "codigoIbge": 2211209,
    "nome": "Uruçuí",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 373
  },
  {
    "codigoIbge": 3550605,
    "nome": "São Roque",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 374
  },
  {
    "codigoIbge": 4303905,
    "nome": "Campo Bom",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 375
  },
  {
    "codigoIbge": 3101607,
    "nome": "Alfenas",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 376
  },
  {
    "codigoIbge": 3524303,
    "nome": "Jaboticabal",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 377
  },
  {
    "codigoIbge": 4322608,
    "nome": "Venâncio Aires",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 378
  },
  {
    "codigoIbge": 3105608,
    "nome": "Barbacena",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 379
  },
  {
    "codigoIbge": 3504503,
    "nome": "Avaré",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 380
  },
  {
    "codigoIbge": 5003207,
    "nome": "Corumbá",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 381
  },
  {
    "codigoIbge": 1718204,
    "nome": "Porto Nacional",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 382
  },
  {
    "codigoIbge": 4219309,
    "nome": "Videira",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 383
  },
  {
    "codigoIbge": 3539301,
    "nome": "Pirassununga",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 384
  },
  {
    "codigoIbge": 3161908,
    "nome": "São Gonçalo do Rio Abaixo",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 385
  },
  {
    "codigoIbge": 5208004,
    "nome": "Formosa",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 386
  },
  {
    "codigoIbge": 3513405,
    "nome": "Cruzeiro",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 387
  },
  {
    "codigoIbge": 1100023,
    "nome": "Ariquemes",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 388
  },
  {
    "codigoIbge": 2804805,
    "nome": "Nossa Senhora do Socorro",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 389
  },
  {
    "codigoIbge": 3169901,
    "nome": "Ubá",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 390
  },
  {
    "codigoIbge": 1503606,
    "nome": "Itaituba",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 391
  },
  {
    "codigoIbge": 4309605,
    "nome": "Horizontina",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 392
  },
  {
    "codigoIbge": 4319901,
    "nome": "Sapiranga",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 393
  },
  {
    "codigoIbge": 4313904,
    "nome": "Panambi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 394
  },
  {
    "codigoIbge": 2500601,
    "nome": "Alhandra",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 395
  },
  {
    "codigoIbge": 4114609,
    "nome": "Marechal Cândido Rondon",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 396
  },
  {
    "codigoIbge": 2918001,
    "nome": "Jequié",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 397
  },
  {
    "codigoIbge": 2503209,
    "nome": "Cabedelo",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 398
  },
  {
    "codigoIbge": 3302205,
    "nome": "Itaperuna",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 399
  },
  {
    "codigoIbge": 3501152,
    "nome": "Alumínio",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 400
  },
  {
    "codigoIbge": 2606804,
    "nome": "Igarassu",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 401
  },
  {
    "codigoIbge": 5003256,
    "nome": "Costa Rica",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 402
  },
  {
    "codigoIbge": 3117504,
    "nome": "Conceição do Mato Dentro",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 403
  },
  {
    "codigoIbge": 5002951,
    "nome": "Chapadão do Sul",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 404
  },
  {
    "codigoIbge": 2606002,
    "nome": "Garanhuns",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 405
  },
  {
    "codigoIbge": 3147907,
    "nome": "Passos",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 406
  },
  {
    "codigoIbge": 4300604,
    "nome": "Alvorada",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 407
  },
  {
    "codigoIbge": 3546702,
    "nome": "Santa Gertrudes",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 408
  },
  {
    "codigoIbge": 4105508,
    "nome": "Cianorte",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 409
  },
  {
    "codigoIbge": 3530508,
    "nome": "Mococa",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 410
  },
  {
    "codigoIbge": 4118402,
    "nome": "Paranavaí",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 411
  },
  {
    "codigoIbge": 4322400,
    "nome": "Uruguaiana",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 412
  },
  {
    "codigoIbge": 1500602,
    "nome": "Altamira",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 413
  },
  {
    "codigoIbge": 3204906,
    "nome": "São Mateus",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 414
  },
  {
    "codigoIbge": 3546405,
    "nome": "Santa Cruz do Rio Pardo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 415
  },
  {
    "codigoIbge": 5106240,
    "nome": "Nova Ubiratã",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 416
  },
  {
    "codigoIbge": 4303004,
    "nome": "Cachoeira do Sul",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 417
  },
  {
    "codigoIbge": 5204508,
    "nome": "Caldas Novas",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 418
  },
  {
    "codigoIbge": 4311809,
    "nome": "Marau",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 419
  },
  {
    "codigoIbge": 3303203,
    "nome": "Nilópolis",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 420
  },
  {
    "codigoIbge": 4304804,
    "nome": "Carlos Barbosa",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 421
  },
  {
    "codigoIbge": 3151206,
    "nome": "Pirapora",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 422
  },
  {
    "codigoIbge": 3171204,
    "nome": "Vespasiano",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 423
  },
  {
    "codigoIbge": 3138203,
    "nome": "Lavras",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 424
  },
  {
    "codigoIbge": 3510401,
    "nome": "Capivari",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 425
  },
  {
    "codigoIbge": 2931350,
    "nome": "Teixeira de Freitas",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 426
  },
  {
    "codigoIbge": 2112001,
    "nome": "Tasso Fragoso",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 427
  },
  {
    "codigoIbge": 1709500,
    "nome": "Gurupi",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 428
  },
  {
    "codigoIbge": 3145208,
    "nome": "Nova Serrana",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 429
  },
  {
    "codigoIbge": 1506138,
    "nome": "Redenção",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 430
  },
  {
    "codigoIbge": 3162500,
    "nome": "São João del Rei",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 431
  },
  {
    "codigoIbge": 3169307,
    "nome": "Três Corações",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 432
  },
  {
    "codigoIbge": 5221858,
    "nome": "Valparaíso de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 433
  },
  {
    "codigoIbge": 2601706,
    "nome": "Belo Jardim",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 434
  },
  {
    "codigoIbge": 2207702,
    "nome": "Parnaíba",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 435
  },
  {
    "codigoIbge": 3556453,
    "nome": "Vargem Grande Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 436
  },
  {
    "codigoIbge": 5007208,
    "nome": "Rio Brilhante",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 437
  },
  {
    "codigoIbge": 3525201,
    "nome": "Jarinu",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 438
  },
  {
    "codigoIbge": 4203600,
    "nome": "Campos Novos",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 439
  },
  {
    "codigoIbge": 5221403,
    "nome": "Trindade",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 440
  },
  {
    "codigoIbge": 3555406,
    "nome": "Ubatuba",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 441
  },
  {
    "codigoIbge": 4208302,
    "nome": "Itapema",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 442
  },
  {
    "codigoIbge": 5007695,
    "nome": "São Gabriel do Oeste",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 443
  },
  {
    "codigoIbge": 5101803,
    "nome": "Barra do Garças",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 444
  },
  {
    "codigoIbge": 5006200,
    "nome": "Nova Andradina",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 445
  },
  {
    "codigoIbge": 1100049,
    "nome": "Cacoal",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 446
  },
  {
    "codigoIbge": 5205471,
    "nome": "Chapadão do Céu",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 447
  },
  {
    "codigoIbge": 3301306,
    "nome": "Casimiro de Abreu",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 448
  },
  {
    "codigoIbge": 4309100,
    "nome": "Gramado",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 449
  },
  {
    "codigoIbge": 4308607,
    "nome": "Garibaldi",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 450
  },
  {
    "codigoIbge": 3533908,
    "nome": "Olímpia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 451
  },
  {
    "codigoIbge": 4322509,
    "nome": "Vacaria",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 452
  },
  {
    "codigoIbge": 2110302,
    "nome": "Santo Antônio dos Lopes",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 453
  },
  {
    "codigoIbge": 5102702,
    "nome": "Canarana",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 454
  },
  {
    "codigoIbge": 4117909,
    "nome": "Palotina",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 455
  },
  {
    "codigoIbge": 4117305,
    "nome": "Ortigueira",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 456
  },
  {
    "codigoIbge": 1600600,
    "nome": "Santana",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 457
  },
  {
    "codigoIbge": 3127107,
    "nome": "Frutal",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 458
  },
  {
    "codigoIbge": 3133709,
    "nome": "Itatiaiuçu",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 459
  },
  {
    "codigoIbge": 3302601,
    "nome": "Mangaratiba",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 460
  },
  {
    "codigoIbge": 3129806,
    "nome": "Ibirité",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 461
  },
  {
    "codigoIbge": 4317509,
    "nome": "Santo Ângelo",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 462
  },
  {
    "codigoIbge": 3168606,
    "nome": "Teófilo Otoni",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 463
  },
  {
    "codigoIbge": 3306107,
    "nome": "Valença",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 464
  },
  {
    "codigoIbge": 3530300,
    "nome": "Mirassol",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 465
  },
  {
    "codigoIbge": 4210100,
    "nome": "Mafra",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 466
  },
  {
    "codigoIbge": 3300308,
    "nome": "Barra do Piraí",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 467
  },
  {
    "codigoIbge": 3118304,
    "nome": "Conselheiro Lafaiete",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 468
  },
  {
    "codigoIbge": 3517406,
    "nome": "Guaíra",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 469
  },
  {
    "codigoIbge": 4218004,
    "nome": "Tijucas",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 470
  },
  {
    "codigoIbge": 3509601,
    "nome": "Campo Limpo Paulista",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 471
  },
  {
    "codigoIbge": 3305208,
    "nome": "São Pedro da Aldeia",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 472
  },
  {
    "codigoIbge": 4202305,
    "nome": "Biguaçu",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 473
  },
  {
    "codigoIbge": 2922003,
    "nome": "Mucuri",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 474
  },
  {
    "codigoIbge": 4213203,
    "nome": "Pomerode",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 475
  },
  {
    "codigoIbge": 5007802,
    "nome": "Selvíria",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 476
  },
  {
    "codigoIbge": 2801207,
    "nome": "Canindé de São Francisco",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 477
  },
  {
    "codigoIbge": 3541604,
    "nome": "Promissão",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 478
  },
  {
    "codigoIbge": 5102686,
    "nome": "Campos de Júlio",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 479
  },
  {
    "codigoIbge": 4206504,
    "nome": "Guaramirim",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 480
  },
  {
    "codigoIbge": 2908507,
    "nome": "Conceição do Jacuípe",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 481
  },
  {
    "codigoIbge": 4219507,
    "nome": "Xanxerê",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 482
  },
  {
    "codigoIbge": 3304003,
    "nome": "Piraí",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 483
  },
  {
    "codigoIbge": 5005707,
    "nome": "Naviraí",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 484
  },
  {
    "codigoIbge": 2111201,
    "nome": "São José de Ribamar",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 485
  },
  {
    "codigoIbge": 3534302,
    "nome": "Orlândia",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 486
  },
  {
    "codigoIbge": 2704708,
    "nome": "Marechal Deodoro",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 487
  },
  {
    "codigoIbge": 5210109,
    "nome": "Ipameri",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 488
  },
  {
    "codigoIbge": 5218508,
    "nome": "Quirinópolis",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 489
  },
  {
    "codigoIbge": 4303509,
    "nome": "Camaquã",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 490
  },
  {
    "codigoIbge": 2513703,
    "nome": "Santa Rita",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 491
  },
  {
    "codigoIbge": 4308201,
    "nome": "Flores da Cunha",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 492
  },
  {
    "codigoIbge": 3302858,
    "nome": "Mesquita",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 493
  },
  {
    "codigoIbge": 3143906,
    "nome": "Muriaé",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 494
  },
  {
    "codigoIbge": 4207304,
    "nome": "Imbituba",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 495
  },
  {
    "codigoIbge": 3531308,
    "nome": "Monte Alto",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 496
  },
  {
    "codigoIbge": 4317103,
    "nome": "Sant'Ana do Livramento",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 497
  },
  {
    "codigoIbge": 5200258,
    "nome": "Águas Lindas de Goiás",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 498
  },
  {
    "codigoIbge": 2925204,
    "nome": "Pojuca",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 499
  },
  {
    "codigoIbge": 3202405,
    "nome": "Guarapari",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.planalto.gov.br/ccivil_03/leis/lcp/lcp116.htm#art8",
    "capturadoEm": "2026-06-26",
    "estimativa": true,
    "pibRank": 500
  },
  {
    "codigoIbge": 2800308,
    "nome": "Aracaju",
    "uf": "SE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.aracaju.se.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1501402,
    "nome": "Belém",
    "uf": "PA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.belem.pa.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 3106200,
    "nome": "Belo Horizonte",
    "uf": "MG",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://prefeitura.pbh.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1400100,
    "nome": "Boa Vista",
    "uf": "RR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.boavista.rr.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 5300108,
    "nome": "Brasília",
    "uf": "DF",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.gov.br/planalto/pt-br",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 5002704,
    "nome": "Campo Grande",
    "uf": "MS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.campogrande.ms.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 5103403,
    "nome": "Cuiabá",
    "uf": "MT",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.cuiaba.mt.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 4106902,
    "nome": "Curitiba",
    "uf": "PR",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.curitiba.pr.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 4205407,
    "nome": "Florianópolis",
    "uf": "SC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.pmf.sc.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2304400,
    "nome": "Fortaleza",
    "uf": "CE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.fortaleza.ce.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 5208707,
    "nome": "Goiânia",
    "uf": "GO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.goiania.go.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2507507,
    "nome": "João Pessoa",
    "uf": "PB",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.joaopessoa.pb.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1600303,
    "nome": "Macapá",
    "uf": "AP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://macapa.ap.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2704302,
    "nome": "Maceió",
    "uf": "AL",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.maceio.al.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1302603,
    "nome": "Manaus",
    "uf": "AM",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.manaus.am.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2408102,
    "nome": "Natal",
    "uf": "RN",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.natal.rn.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1721000,
    "nome": "Palmas",
    "uf": "TO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.palmas.to.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 4314902,
    "nome": "Porto Alegre",
    "uf": "RS",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.portoalegre.rs.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1100205,
    "nome": "Porto Velho",
    "uf": "RO",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.portovelho.ro.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2611606,
    "nome": "Recife",
    "uf": "PE",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.recife.pe.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 1200401,
    "nome": "Rio Branco",
    "uf": "AC",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.riobranco.ac.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 3304557,
    "nome": "Rio de Janeiro",
    "uf": "RJ",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.rio.rj.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2927408,
    "nome": "Salvador",
    "uf": "BA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.salvador.ba.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2111300,
    "nome": "São Luís",
    "uf": "MA",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.saoluis.ma.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 3550308,
    "nome": "São Paulo",
    "uf": "SP",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://legislacao.prefeitura.sp.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 2211001,
    "nome": "Teresina",
    "uf": "PI",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.teresina.pi.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  },
  {
    "codigoIbge": 3205309,
    "nome": "Vitória",
    "uf": "ES",
    "aliquotaMin": 2,
    "aliquotaMax": 5,
    "leiUrl": "https://www.vitoria.es.gov.br/",
    "capturadoEm": "2026-06-26",
    "estimativa": false,
    "pibRank": null
  }
]
